module.exports = __webpack_public_path__ + "static/media/icon_reject.e95e2998.svg";